import React, { useState, useRef, useEffect } from 'react';
import {
    FormControl, FormControlLabel, Typography, TextField, RadioGroup, Radio, Checkbox,
    Button, Box, FormHelperText, Autocomplete
} from '@mui/material';
// import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import dayjs from 'dayjs';
// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Formik, useFormik } from 'formik';
import * as yup from 'yup';
import { useSelector, useDispatch } from 'react-redux';
import { fetchSuppliersByCompanyId, resetOrderState } from '../../../redux/orderSlice';
import { useLocation,useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getDate } from '../../../helpers/helperFunction';

dayjs.extend(localizedFormat);
const formattedDate = dayjs().format('LL');


// Create a new object with the shape of our input initial state variable.const 

export const CREATE_ORDER_VALIDATION = yup.object().shape({
    orderNumber: yup.string().required('Purchase Order cannot be empty.'),
    supplierCompanyKeyId: yup.string().required('Supplier is required.'),
    orderDate: yup.date().required('Order date is required.'),
    orderExpectedDate: yup.date().required('Order due date is required.'),
    orderDescription: yup.string().max(300, 'Address cannot exceed 300 characters.'),

})
const CreateOrder = ({ onSubmit, handleStepChange, initialValues, actionType }) => {
    const dispatch = useDispatch()
    const location = useLocation()
    const navigate = useNavigate()
    const { t } = useTranslation()


    const defaultValues = {
        supplierCompanyKeyId: '',
        // orderCompanyKeyId:1,
        orderDate: dayjs(),
        orderNumber: '',
        orderStatus: 'Open',
        // createdBy:224,
        orderDescription: '',
        orderExpectedDate: dayjs()
    }
   
    const editValue = (actionType === 'edit' || location.state?.actionType === 'edit') ? {
        orderNumber: initialValues?.orderNumber || '',
        supplierCompanyKeyId: initialValues?.supplierCompany?.companyKeyId || '',
        orderDate: initialValues?.orderDate ? dayjs(initialValues.orderDate) : dayjs(),
        orderExpectedDate: initialValues?.orderExpectedDate ? dayjs(initialValues.orderExpectedDate) : dayjs(),
        orderDescription: initialValues?.orderDescription || '',
        // userId:1
    } : defaultValues;

    const supplierList = useSelector(state => state.order.suppliers.data || []);
    const [modalOpen, setModalOpen] = useState(false);

    const supplierOptions = supplierList.map((supplier) => ({
        label: supplier.company_name, // Displayed in the dropdown
        value: supplier.company_key_id, // Actual value when an option is selected
    }));
    console.log(">>:: CREAT ORDER ::>>>", initialValues,actionType , location.state?.actionType)
    const isLoading  = useSelector(state => Object.values(state.order.loading).some(status => status));

    useEffect(() => {
        dispatch(resetOrderState());
        dispatch(fetchSuppliersByCompanyId());
    }, [dispatch]);
    return (
        <>

            {/* with Formik */}
            <Formik
                // initialValues={editValue || defaultValues}
                initialValues={editValue}
                enableReinitialize={true}
                validationSchema={CREATE_ORDER_VALIDATION}
                onSubmit={(values, { setSubmitting }) => {
                    const formattedValues = {
                        ...values,
                        orderDate: getDate(values.orderDate),
                        orderExpectedDate: getDate(values.orderExpectedDate)
                    };
                    console.log('Formatted Submit:', formattedValues);
                    onSubmit(formattedValues);
                    setSubmitting(false);
                }}

            >
                {({ values, errors, handleChange, handleBlur, handleSubmit, setFieldValue, touched }) => (
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <div className="col-md-6 cs-form mb-3">
                                <TextField
                                    label={t('createOrder.purchaseOrder')}
                                    className='md-input'
                                    name='orderNumber'
                                    value={values.orderNumber}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.orderNumber}
                                    helperText={errors.orderNumber}
                                />
                            </div>
                            <div className="col-md-6 cs-form mb-3">

                                <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    className='md-input'
                                    options={supplierOptions}
                                    getOptionLabel={(option) => option.label || ''}
                                    value={supplierOptions.find(option => option.value === values.supplierCompanyKeyId) || null}
                                    onChange={(event, newValue) => {
                                        handleChange({ target: { name: 'supplierCompanyKeyId', value: newValue?.value || '' } });
                                    }}
                                    onBlur={handleBlur}
                                    // disabled={actionType === 'edit'} 
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={t('createOrder.supplier')}
                                            error={touched.supplierCompanyKeyId && Boolean(errors.supplierCompanyKeyId)}
                                            helperText={touched.supplierCompanyKeyId && errors.supplierCompanyKeyId}
                                        />
                                    )}
                                />
                            </div>
                            <div className="col-md-6 cs-form mb-3">
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label={t('createOrder.orderDate')}
                                        className='md-input'
                                        value={values.orderDate}
                                        onChange={(newValue) => {
                                            setFieldValue('orderDate', newValue);
                                        }}
                                        // disabled={actionType === 'edit'} 
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                className='md-input'
                                                error={errors.orderDate}
                                                helperText={errors.orderDate}
                                            />
                                        )}
                                    />
                                </LocalizationProvider>
                            </div>
                            <div className="col-md-6 cs-form mb-3">
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label={t('createOrder.orderDue')}
                                        className='md-input'
                                        value={values.orderExpectedDate}
                                        onChange={(newValue) => {
                                            setFieldValue('orderExpectedDate', newValue);
                                        }}
                                        // disabled={actionType === 'edit'} 
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                className='md-input'
                                                error={errors.orderExpectedDate}
                                                helperText={errors.orderExpectedDate}
                                            />
                                        )}
                                    />
                                </LocalizationProvider>
                            </div>
                            <div className="col-md-12 cs-form mb-3">
                                <TextField
                                    label={t('createOrder.description')}
                                    className='md-input'
                                    name='orderDescription'
                                    multiline
                                    rows={4}
                                    value={values.orderDescription}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.orderDescription}
                                    // helperText={.errors.orderDescription}
                                    inputProps={{
                                        maxLength: 300,
                                    }}
                                    helperText={`${values.orderDescription.length}/300`}
                                />
                            </div>
                            {/* <div className="col-md-12 cs-form mb-3  ">
                            
                            </div> */}
                            <div className="d-flex justify-content-between">
                                <button type="button" className="btn btn-light grey-btn lg-btn" onClick={() => navigate(-1)}>{t('createOrder.back')}</button>
                                {/* <Button color="primary" variant="contained" type="submit" disabled={isSubmitting}>
                                Create Order
                                
                            </Button> */}
                                <button
                                    className="btn btn-primary greeen-btn lg-btn"
                                    type='submit'
                                    variant="contained"
                                    onClick={handleSubmit} // Use onClick to trigger form submission
                                // disabled={ isValid || isSubmitting }
                                >
                                    {/* Create Order */}
                                    {isLoading ? 'Submitting...' : t('createOrder.createOrderbtn') }
                                </button>
                            </div>
                            {/* <button type="submit" className="btn btn-primary greeen-btn lg-btn" disabled={loading}>
                                    {loading ? 'Submitting...' : 'Create Order'}</button>
                            </div> */}
                            {/* ... other input fields */}
                        </div>
                    </form>
                )}
            </Formik >
        </>
    )
}
export default CreateOrder